/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SequenceFeatureTypeColorSetting } from './SequenceFeatureTypeColorSetting';
import {
    SequenceFeatureTypeColorSettingFromJSON,
    SequenceFeatureTypeColorSettingFromJSONTyped,
    SequenceFeatureTypeColorSettingToJSON,
} from './SequenceFeatureTypeColorSetting';
import type { SequenceType } from './SequenceType';
import {
    SequenceTypeFromJSON,
    SequenceTypeFromJSONTyped,
    SequenceTypeToJSON,
} from './SequenceType';

/**
 * Persist feature color. Always assigned to the current user.
 * @export
 * @interface SaveSequenceFeatureColorRequest
 */
export interface SaveSequenceFeatureColorRequest {
    /**
     * 
     * @type {SequenceType}
     * @memberof SaveSequenceFeatureColorRequest
     */
    sequenceType: SequenceType;
    /**
     * 
     * @type {string}
     * @memberof SaveSequenceFeatureColorRequest
     */
    label?: string;
    /**
     * hex color
     * @type {string}
     * @memberof SaveSequenceFeatureColorRequest
     */
    color?: string;
    /**
     * 
     * @type {SequenceFeatureTypeColorSetting}
     * @memberof SaveSequenceFeatureColorRequest
     */
    setting?: SequenceFeatureTypeColorSetting;
    /**
     * 
     * @type {number}
     * @memberof SaveSequenceFeatureColorRequest
     */
    featureTypeId?: number;
    /**
     * Clear all existing colors and settings for the given feature type and all related feature names
     * @type {boolean}
     * @memberof SaveSequenceFeatureColorRequest
     */
    clearAll?: boolean;
}

/**
 * Check if a given object implements the SaveSequenceFeatureColorRequest interface.
 */
export function instanceOfSaveSequenceFeatureColorRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sequenceType" in value;

    return isInstance;
}

export function SaveSequenceFeatureColorRequestFromJSON(json: any): SaveSequenceFeatureColorRequest {
    return SaveSequenceFeatureColorRequestFromJSONTyped(json, false);
}

export function SaveSequenceFeatureColorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveSequenceFeatureColorRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sequenceType': SequenceTypeFromJSON(json['sequenceType']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'setting': !exists(json, 'setting') ? undefined : SequenceFeatureTypeColorSettingFromJSON(json['setting']),
        'featureTypeId': !exists(json, 'featureTypeId') ? undefined : json['featureTypeId'],
        'clearAll': !exists(json, 'clearAll') ? undefined : json['clearAll'],
    };
}

export function SaveSequenceFeatureColorRequestToJSON(value?: SaveSequenceFeatureColorRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sequenceType': SequenceTypeToJSON(value.sequenceType),
        'label': value.label,
        'color': value.color,
        'setting': SequenceFeatureTypeColorSettingToJSON(value.setting),
        'featureTypeId': value.featureTypeId,
        'clearAll': value.clearAll,
    };
}

